/**
 * @desc Snowmaking hydrants state actions, mutations and default state values
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

export default {
  state: {
    name: "blackcombgondola",
    layerTitle: "Blackcomb Gondola",
    geojson: [],
    visibility: {
      mapView: false,
      listView: false,
      singleView: false,
      singleId: 0
    },
    loading: false,
    hasListView: false,
    splitIndex: 0,
    legend: [
      {
        id: 0,
        name: "Travel From",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/liftops/arrow_blue.png"
      },
      {
        id: 1,
        name: "Travel To",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/liftops/arrow_yellow_new.png"
      },
      {
        id: 2,
        name: "Mandatory Stop Point",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/liftops/stop_lift_ops.png"
      }
    ]
  }
};
